<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("administrative_concepts.concept_placeholder")' :danger="$v.form.concept.$invalid && $v.form.concept.$model" :danger-text="$t('validation.required', { attribute: $t('administrative_concepts.concept') })" v-model="form.concept" :label='$t("administrative_concepts.concept")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('AdministrativeConcepts')

export default {
  name: 'ModalAdministrativeConcepts',
  mixins: [ModalMixin1],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: true
    }
  },
  // data: () => ({}),
  validations () {
    return {
      form: {
        concept: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    close () {
      this.$emit('closeModal')
    },
    saveRecord () {
      this.isAdd ? this.addRecord(this.form) : this.editRecord(this.form)
      this.$emit('updateRecords', this.form)
      this.close()
    }
  }
}
</script>
